import { createSlice } from '@reduxjs/toolkit';

import portableSpeakers from './MarshallData/portableSpeakers';
import headphones from './MarshallData/headphones';
import iphoneData from './Apple/iphone/iphone';
import { airpodsProductDetails } from './Apple/airpods/airpods';
import { macProducts } from './Apple/mac/mac';
import { iPadProducts } from './Apple/ipad/ipad';
import { appleWatchProducts } from './Apple/applewatch/applewatch';
import { galaxySSeries } from './Samsung/galaxyS';
import { galaxyASeries } from './Samsung/galaxyA';
import { galaxyFSeries } from './Samsung/galaxyF';
import { galaxyZSeries } from './Samsung/galaxyZ';
import { tab } from './Samsung/tab';
import iphonecase from './Muvtech/Iphonecase';
import airpodscase from './Muvtech/airpodscase';
import samsungcase from './Muvtech/samsungcase';
import samsungglass from './Muvtech/samsungglass';
import powerbank from './Muvtech/powerbank';
import ipadcase from './Muvtech/Ipadcase';
import ipadglass from './Muvtech/Ipadglass';
import wallcharger from './Muvtech/wallcharger';
import onePlusData from './OnePlus/oneplus';

const initialState = {
  portableSpeakers,
  headphones,
  iphoneData,
  airpodsProductDetails,
  macProducts,
  iPadProducts,
  appleWatchProducts,
  galaxySSeries,
  galaxyASeries,
  galaxyFSeries,
  galaxyZSeries,
  tab,
  iphonecase,
  airpodscase,
  samsungcase,
  samsungglass,
  powerbank,
  ipadcase,
  ipadglass,
  wallcharger,
  onePlusData,
  selectedProduct: null,
};

const productSlice = createSlice({
  name: 'Products',
  initialState,
  reducers: {
    setSelectedProduct: (state, action) => {
      state.selectedProduct = action.payload;
    },
  },
});

export const { setSelectedProduct } = productSlice.actions;
export default productSlice.reducer;
